export const IconeBandeiraAlemanha = () => (
    <img
       alt=""
       style={{ height: '25px' }}
       src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADUAAAAjCAYAAAA0aUL2AAAAAXNSR0IArs4c6QAAAHtJREFUWEftmLENwDAMw+T/j+sHeSW9QRMRg50FCCY1BJ0kN8u+8ahHjGrqEVHRlKZAAs4PhF9Va6rCBYbnbHz7eRQ4qaba+TW0yKymSPpNt6YaWmRWUyT9pnvut/AXmUc1GwCzzg+EX1VrqsIFhjUFwq+qNVXhAsMrTf3AfkIzUxfpgQAAAABJRU5ErkJggg=="
    />
 );